var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#8533eb",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M241.671 354.92l-6.75 6.75c-.22.22-.508.33-.796.33-.288 0-.576-.11-.795-.33l-3-3c-.44-.439-.44-1.15 0-1.59.44-.44 1.15-.44 1.59 0l2.205 2.204 5.954-5.954c.44-.44 1.151-.44 1.59 0 .44.44.441 1.15.002 1.59z",
    transform: "translate(-545 -524) translate(315 171)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVPurple);
export default __webpack_public_path__ + "static/media/v-purple.2b6113f4b2280f7fbb1b380e6ac37e58.svg";
export { ForwardRef as ReactComponent };